import Navbar from "../Navbar/Navbar";
import MyAccountInfo from "./MyAccountInfo";
import SideMenu from "./SideMenu";

function MyAccount() {
    return (
        <>
            <Navbar />
            <div className="flex flex-row items-start">
                <SideMenu />
                <div className="flex flex-col overflow-auto">
                    <MyAccountInfo />
                </div>
            </div>
        </>
    );
}

export default MyAccount;
